import { render, staticRenderFns } from "./DonutChart46.vue?vue&type=template&id=84762c88&scoped=true"
import script from "./DonutChart46.vue?vue&type=script&lang=js"
export * from "./DonutChart46.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84762c88",
  null
  
)

export default component.exports